"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var utilities_1 = require("../utilities");
var ELEMENT_NAME_TAG_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, 'block-quote', 'blockquote'), 'heading-one', 'h1'), 'heading-two', 'h2'), 'list-item', 'li'), 'numbered-list', 'ol'), 'bulleted-list', 'ul'), "paragraph", 'p');
var MARK_ELEMENT_TAG_MAP = {
  strikethrough: ['s'],
  bold: ['strong'],
  underline: ['u'],
  italic: ['i'],
  code: ['pre', 'code']
};
exports.config = {
  markMap: MARK_ELEMENT_TAG_MAP,
  elementMap: ELEMENT_NAME_TAG_MAP,
  elementTransforms: {},
  elementAttributeTransform: function elementAttributeTransform(_ref) {
    var node = _ref.node;
    var elementStyleMap = {
      align: 'textAlign'
    };
    var attribs = (0, utilities_1.styleMapToAttribs)({
      elementStyleMap: elementStyleMap,
      node: node
    });
    return (0, utilities_1.isEmptyObject)(attribs) ? {} : attribs;
  },
  encodeEntities: true
};